<template>
  <div>
    <b-carousel
      id="carousel-1"
      fade
      v-model="slide"
      :interval="8000"
      controls
      indicators
      @sliding-start="onSlideStart"
      @sliding-end="onSlideEnd"
    >
      <b-carousel-slide>
        <template v-slot:img>
          <img
            src="https://flyfishingpics.s3.eu-north-1.amazonaws.com/tinified-trysilelva/Trysilelva-1.jpg"
            alt="image slot"
          />
        </template>
        <h1>Trysilelva</h1>
        <p>Text under brubrik och bild</p>
      </b-carousel-slide>
      <b-carousel-slide>
        <template v-slot:img>
          <img
            src="https://flyfishingpics.s3.eu-north-1.amazonaws.com/tinified-trysilelva/Trysilelva-2.jpg"
            alt="image slot"
          />
        </template>
        <h1>Trysilelva</h1>
        <p>Text under brubrik och bild</p>
      </b-carousel-slide>
      <b-carousel-slide>
        <template v-slot:img>
          <img
            src="https://flyfishingpics.s3.eu-north-1.amazonaws.com/tinified-trysilelva/Trysilelva-3.jpg"
            alt="image slot"
          />
        </template>
        <h1>Trysilelva</h1>
        <p>Text under brubrik och bild</p>
      </b-carousel-slide>
      <b-carousel-slide>
        <template v-slot:img>
          <img
            src="https://flyfishingpics.s3.eu-north-1.amazonaws.com/tinified-trysilelva/Trysilelva-4.jpg"
            alt="image slot"
          />
        </template>
        <h1>Trysilelva</h1>
        <p>Text under brubrik och bild</p>
      </b-carousel-slide>
      <b-carousel-slide>
        <template v-slot:img>
          <img
            src="https://flyfishingpics.s3.eu-north-1.amazonaws.com/tinified-trysilelva/Trysilelva-5.jpg"
            alt="image slot"
          />
        </template>
        <h1>Trysilelva</h1>
        <p>Text under brubrik och bild</p>
      </b-carousel-slide>
      <b-carousel-slide>
        <template v-slot:img>
          <img
            src="https://flyfishingpics.s3.eu-north-1.amazonaws.com/tinified-trysilelva/Trysilelva-6.jpg"
            alt="image slot"
          />
        </template>
        <h1>Trysilelva</h1>
        <p>Text under brubrik och bild</p>
      </b-carousel-slide>
      <b-carousel-slide>
        <template v-slot:img>
          <img
            src="https://flyfishingpics.s3.eu-north-1.amazonaws.com/tinified-trysilelva/Trysilelva-7.jpg"
            alt="image slot"
          />
        </template>
        <h1>Trysilelva</h1>
        <p>Text under brubrik och bild</p>
      </b-carousel-slide>
      <b-carousel-slide>
        <template v-slot:img>
          <img
            src="https://flyfishingpics.s3.eu-north-1.amazonaws.com/tinified-trysilelva/Trysilelva-8.jpg"
            alt="image slot"
          />
        </template>
        <h1>Trysilelva</h1>
        <p>Text under brubrik och bild</p>
      </b-carousel-slide>
      <b-carousel-slide>
        <template v-slot:img>
          <img
            src="https://flyfishingpics.s3.eu-north-1.amazonaws.com/tinified-trysilelva/Trysilelva-9.jpg"
            alt="image slot"
          />
        </template>
        <h1>Trysilelva</h1>
        <p>Text under brubrik och bild</p>
      </b-carousel-slide>
      <b-carousel-slide>
        <template v-slot:img>
          <img
            src="https://flyfishingpics.s3.eu-north-1.amazonaws.com/tinified-trysilelva/Trysilelva-10.jpg"
            alt="image slot"
          />
        </template>
        <h1>Trysilelva</h1>
        <p>Text under brubrik och bild</p>
      </b-carousel-slide>
    </b-carousel>

    <!--     <p class="mt-1" style="color: white">
      Slide #: {{ slide }}<br />
      Sliding: {{ sliding }}
    </p> -->
  </div>
</template>

<script>
export default {
  name: "About",
  data() {
    return {
      slide: 0,
      sliding: null
    };
  },
  methods: {
    onSlideStart() {
      this.sliding = true;
    },
    onSlideEnd() {
      this.sliding = false;
    }
  }
};
// @ is an alias to /src
</script>
